$(function () {
    $.fn.swipe = function (callback) {
        var touchDown = false,
          originalPosition = null,
          $el = $(this);

        function swipeInfo(event) {
            console.log(event);
            var x = event.originalEvent.pageX || event.originalEvent.targetTouches[0].pageX,
              y = event.originalEvent.pageY || event.originalEvent.targetTouches[0].pageY,
              dx, dy;

            dx = (x > originalPosition.x) ? "right" : "left";
            dy = (y > originalPosition.y) ? "down" : "up";

            return {
                direction: {
                    x: dx,
                    y: dy
                },
                offset: {
                    x: x - originalPosition.x,
                    y: originalPosition.y - y
                }
            };
        }

        $el.on("touchstart mousedown", function (event) {
            event.preventDefault();

            touchDown = true;
            originalPosition = {
                x: event.originalEvent.pageX || event.originalEvent.targetTouches[0].pageX,
                y: event.originalEvent.pageY || event.originalEvent.targetTouches[0].pageY
            };
        });

        $el.on("touchend mouseup", function () {
            touchDown = false;
            originalPosition = null;
        });

        $el.on("mousemove", function (event) {
            if (!touchDown) { return; }
            var info = swipeInfo(event);
            callback(info.direction, info.offset);
        });

        $el.on("touchmove", function (event) {
            if (!touchDown) { return; }
            var info = swipeInfo(event);
            callback(info.direction, info.offset);

            touchDown = false;
            originalPosition = null;
        });

        return true;
    };
});

(function ($) {
    var elts = [];
    var pagination;
    var prev = -1;
    var current = 0;
    var offset = 0;
    var that;
    var lastScrollTop = 0;
    var startY = 0;

    $.fn.euroviaSlider = function (options) {
        // Establish our default settings
        var settings = $.extend({
            delay: 10000
        }, options);
        var offsetDelta = 141;//$("header").outerHeight();
        that = this;

        //console.log(window.location.href);
        //console.log(window.location.hostname);
        //console.log(window.location.host);

        if ($("[data-pos]").length > 0) {
            manageOverflow('hidden');
        }

        pagination = addPagination();
        setDimensions();

        offset = $(that).height() + offsetDelta;
        $("[data-id]").not(".firstSlide").css("top", offset);

        pagination.find(".pager").each(function (i, obj) {
            $(obj).click(function (e) {
                e.preventDefault();

                offset = $(that).height() + offsetDelta;
                var next = $(obj).attr('data-moveTo');
                $(that).moveTo(next);
            });
        });

        $(window).on('mousewheel DOMMouseScroll', function (e) {
            offset = $(that).height() + offsetDelta;
            var nnext = 0;
            var direction = (function () {
                var delta = (e.type === 'DOMMouseScroll' ?
                e.originalEvent.detail * -40 :
                e.originalEvent.wheelDelta);
                return delta > 0 ? 0 : 1;
            }());

            if (direction === 1) {
                nnext = parseInt(current) + 1;
            }
            if (direction === 0) {
                nnext = parseInt(current) - 1;
            }

            if (nnext > -1 && nnext < $(that).find("[data-pos]").length / 2) {
                $(that).moveTo(nnext);
            } else {
                //console.log('nnext ' + nnext);
                //console.log('$(that).find("[data-pos]").length ' + $(that).find("[data-pos]").length);
            }
        });

        $(that).swipe(function (direction, offset) {
            console.log("Moving", direction.x, "and", direction.y);
            console.log("Touch moved by", offset.x, "horizontally and", offset.y, "vertically");

            var nnext = 0;
            var direction = offset.y < 0;

            if (offset.y == 0) {
                return;
            }

            if (!direction) {
                nnext = parseInt(current) + 1;
            }
            else{
                nnext = parseInt(current) - 1;
            }

            if (nnext > -1 && nnext < $(that).find("[data-pos]").length / 2) {
                $(that).moveTo(nnext);
            } else {
                //console.log('nnext ' + nnext);
                //console.log('$(that).find("[data-pos]").length ' + $(that).find("[data-pos]").length);
            }
        });

        $(window).resize(function () {
            setDimensions();
        });

        //GESTION URL HASH
        var hash = window.location.hash;
        //console.log(hash);
        if (hash != "") {
            var id = $("[data-hash=" + hash + "]:first").attr("data-id");
            $(".pager").eq(id).click();
        }
    };

    $.fn.moveTo = function (next) {
        if (next != current) {
            updateLinkedZone(current, next);

            if (next == 0) {
                var leftMove = $("[data-id=" + current + "][data-pos=left]");
                var rightMove = $("[data-id=" + current + "][data-pos=right]");
                var leftCurrent = $("[data-id=" + current + "][data-pos=left]");
                var rightCurrent = $("[data-id=" + current + "][data-pos=right]");

                $(".pager:eq(" + current + ")").removeClass("active");
                $(".pager:eq(" + next + ")").addClass("active");

                var zindex = parseInt(leftCurrent.css("z-index")) + 5;
                leftMove.css("z-index", zindex).addClass("firstSlide");
                rightMove.css("z-index", zindex).addClass("firstSlide");
                $("[data-id=" + next + "].slideContentLeft").addClass("firstSlide").css({ "z-index": 5 });

                leftMove.velocity({
                    top: offset
                },
                    1000
                );
                rightMove.velocity({
                    top: -offset
                },
                    1000
                );
            } else {
                var leftMove = $("[data-id=" + next + "][data-pos=left]");
                var rightMove = $("[data-id=" + next + "][data-pos=right]");

                var leftCurrent = $("[data-id=" + current + "][data-pos=left]");
                var rightCurrent = $("[data-id=" + current + "][data-pos=right]");
                var toDown = false;

                $(".pager:eq(" + current + ")").removeClass("active");
                $(".pager:eq(" + next + ")").addClass("active");
                //console.log("offset: " + offset);
                if (next > current) {
                    //next gauche vient du bas et next droit vient du haut
                    leftMove.css("top", offset);
                    rightMove.css("top", -offset);
                    toDown = true;
                } else {
                    //inversement
                    leftMove.css("top", -offset);
                    rightMove.css("top", offset);
                    toDown = false;
                }

                if (!toDown) {
                    var zindex = parseInt(leftCurrent.css("z-index")) + 5;
                    leftMove.css("z-index", zindex).addClass("firstSlide");
                    rightMove.css("z-index", zindex).addClass("firstSlide");
                }

                leftMove.velocity({
                    top: 0
                },
                    1000,
                    function () {
                        complete(leftCurrent, rightCurrent, toDown);
                    }
                );
                rightMove.velocity({
                    top: 0
                },
                    1000,
                    function () {
                        complete(leftCurrent, rightCurrent, toDown);
                    }
                );

                if (toDown) {
                    var zindex = parseInt(leftCurrent.css("z-index")) + 2
                    leftMove.css("z-index", zindex).addClass("firstSlide");
                    rightMove.css("z-index", zindex).addClass("firstSlide");
                }
            }

            current = next;
        } else {
            //console.log("nothing to move");
        }
    }

    function RemoveIndication() {
        if ($(".scrollIndication").length > 0) {
            $(".scrollIndication").fadeOut();
        }
    }

    function updateLinkedZone(current, next) {
        $("[data-scroll=" + next + "]").parent().addClass("current");
        $("[data-scroll=" + current + "]").parent().removeClass("current");
    }

    function complete(leftCurrent, rightCurrent, toDown) {
        RemoveIndication();

        leftCurrent.removeClass("firstSlide");
        rightCurrent.removeClass("firstSlide");

        leftCurrent.css("z-index", -1);
        rightCurrent.css("z-index", -1);
    }

    function addPagination() {
        var pager = '<div class="sliderPagination">';
        for (i = 0; i < $(that).find("[data-pos]").length / 2; i++) {
            pager += '<div class="pager ' + (i == 0 ? "active" : "") + '" data-moveTo="' + i + '"></div>';
        }
        pager += '</div>';
        $(that).append(pager);

        return $(".sliderPagination");
    }

    function setDimensions() {
        //console.log(that);
        var windowHeight = $(window).height();
        var headerHeight = $("header").outerHeight();
        //console.log("windowHeight " + windowHeight);
        //console.log("headerHeight " + headerHeight);

        var height = windowHeight - headerHeight;
        //console.log("height " + height);
        //var width = $(window).width();

        //console.log("no top");
        $(that).css("top", 0);
        $(that).css("height", height);
        //$(that).css("width", width);

        //$(".slideContentLeft").css("height", height).not(".full").css("width", width / 2);
        //$(".slideContentRight").css("height", height).not(".full").css("width", width / 2);

        pagerHeight = $(".sliderPagination").height();
        //console.log("pagerHeight " + pagerHeight);
        var pagerTop = (height / 2) - (pagerHeight / 2);
        //pagerTop
        //console.log("pagerTop " + pagerTop);
        $(".sliderPagination").css("top", pagerTop);

        $("[data-vcentered]").each(function (i, obj) {
            var height = $(that).height();
            var VCheight = $(obj).height();
            $(obj).css("padding-top", (height - VCheight) / 2);
            $(obj).css("padding-bottom", (height - VCheight) / 2);
        });
    }

    function manageOverflow(mode) {
        $("body").css("overflow", mode);
        $("html").css("overflow", mode);
    }
}(jQuery));
/*
 * YoutubeBackground - A wrapper for the Youtube API - Great for fullscreen background videos or just regular videos.
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 *
 * Version:  1.0.1
 *
 */

// Chain of Responsibility pattern. Creates base class that can be overridden.
if (typeof Object.create !== "function") {
    Object.create = function (obj) {
        function F() { }
        F.prototype = obj;
        return new F();
    };
}

(function ($, window, document) {
    var
        loadAPI = function loadAPI(callback) {
            // Load Youtube API
            var tag = document.createElement('script'),
                head = document.getElementsByTagName('head')[0];

            if (window.location.origin == 'file://') {
                tag.src = 'http://www.youtube.com/iframe_api';
            } else {
                tag.src = '//www.youtube.com/iframe_api';
            }

            head.appendChild(tag);

            // Clean up Tags.
            head = null;
            tag = null;

            iframeIsReady(callback);
        },
        iframeIsReady = function iframeIsReady(callback) {
            // Listen for Gobal YT player callback
            if (typeof YT === 'undefined' && typeof window.loadingPlayer === 'undefined') {
                // Prevents Ready Event from being called twice
                window.loadingPlayer = true;

                // Creates deferred so, other players know when to wait.
                window.dfd = $.Deferred();
                window.onYouTubeIframeAPIReady = function () {
                    window.onYouTubeIframeAPIReady = null;
                    window.dfd.resolve("done");
                    callback();
                };
            } else if (typeof YT === 'object') {
                callback();
            } else {
                window.dfd.done(function (name) {
                    callback();
                });
            }
        };

    // YTPlayer Object
    YTPlayer = {
        player: null,

        // Defaults
        defaults: {
            ratio: 16 / 9,
            videoId: 'LSmgKRx5pBo',
            mute: true,
            repeat: true,
            width: $(window).width(),
            playButtonClass: 'YTPlayer-play',
            pauseButtonClass: 'YTPlayer-pause',
            muteButtonClass: 'YTPlayer-mute',
            volumeUpClass: 'YTPlayer-volume-up',
            volumeDownClass: 'YTPlayer-volume-down',
            start: 0,
            pauseOnScroll: false,
            fitToBackground: true,
            playerVars: {
                iv_load_policy: 3,
                modestbranding: 1,
                autoplay: 1,
                controls: 0,
                showinfo: 0,
                wmode: 'opaque',
                branding: 0,
                autohide: 0,
                rel: 0
            },
            events: null
        },

        /**
         * @function init
         * Intializes YTPlayer object
         */
        init: function init(node, userOptions) {
            var self = this;

            self.userOptions = userOptions;

            self.$body = $('body'),
                self.$node = $(node),
                self.$window = $(window);

            // Setup event defaults with the reference to this
            self.defaults.events = {
                'onReady': function (e) {
                    self.onPlayerReady(e);

                    // setup up pause on scroll
                    if (self.options.pauseOnScroll) {
                        self.pauseOnScroll();
                    }

                    // Callback for when finished
                    if (typeof self.options.callback == 'function') {
                        self.options.callback.call(this);
                    }
                },
                'onStateChange': function (e) {
                    if (e.data === 1) {
                        self.$node.find('img').fadeOut(400);
                        self.$node.addClass('loaded');
                    } else if (e.data === 0 && self.options.repeat) { // video ended and repeat option is set true
                        self.player.seekTo(self.options.start);
                    }
                }
            }

            self.options = $.extend(true, {}, self.defaults, self.userOptions);
            self.options.height = Math.ceil(self.options.width / self.options.ratio);
            self.ID = (new Date()).getTime();
            self.holderID = 'YTPlayer-ID-' + self.ID;

            if (self.options.fitToBackground) {
                self.createBackgroundVideo();
            } else {
                self.createContainerVideo();
            }
            // Listen for Resize Event
            self.$window.on('resize.YTplayer' + self.ID, function () {
                self.resize(self);
            });

            loadAPI(self.onYouTubeIframeAPIReady.bind(self));

            self.resize(self);

            return self;
        },

        /**
         * @function pauseOnScroll
         * Adds window events to pause video on scroll.
         */
        pauseOnScroll: function pauseOnScroll() {
            var self = this;
            self.$window.on('scroll.YTplayer' + self.ID, function () {
                var state = self.player.getPlayerState();
                if (state === 1) {
                    self.player.pauseVideo();
                }
            });
            self.$window.scrollStopped(function () {
                var state = self.player.getPlayerState();
                if (state === 2) {
                    self.player.playVideo();
                }
            });
        },
        /**
         * @function createContainerVideo
         * Adds HTML for video in a container
         */
        createContainerVideo: function createContainerVideo() {
            var self = this;

            /*jshint multistr: true */
            var $YTPlayerString = $('<div id="ytplayer-container' + self.ID + '" >\
                                    <div id="' + self.holderID + '" class="ytplayer-player"></div> \
                                    </div> \
                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');

            self.$node.append($YTPlayerString);
            self.$YTPlayerString = $YTPlayerString;
            $YTPlayerString = null;
        },

        /**
         * @function createBackgroundVideo
         * Adds HTML for video background
         */
        createBackgroundVideo: function createBackgroundVideo() {
            /*jshint multistr: true */
            var self = this,
                $YTPlayerString = $('<div id="ytplayer-container' + self.ID + '" class="ytplayer-container background">\
                                    <div id="' + self.holderID + '" class="ytplayer-player"></div>\
                                    </div>\
                                    <div id="ytplayer-shield" class="ytplayer-shield"></div>');

            self.$node.append($YTPlayerString);
            self.$YTPlayerString = $YTPlayerString;
            $YTPlayerString = null;
        },

        /**
         * @function resize
         * Resize event to change video size
         */
        resize: function resize(self) {
            //var self = this;
            var container = $(window);

            if (!self.options.fitToBackground) {
                container = self.$node;
            }

            var width = container.width(),
                pWidth, // player width, to be defined
                height = container.height(),
                pHeight, // player height, tbd
                $YTPlayerPlayer = $('#' + self.holderID);

            // when screen aspect ratio differs from video, video must center and underlay one dimension
            if (width / self.options.ratio < height) {
                pWidth = Math.ceil(height * self.options.ratio); // get new player width
                $YTPlayerPlayer.width(pWidth).height(height).css({
                    left: (width - pWidth) / 2,
                    position: "absolute",
                    "z-index": "-1",
                    top: 0
                }); // player width is greater, offset left; reset top
            } else { // new video width < window width (gap to right)
                pHeight = Math.ceil(width / self.options.ratio); // get new player height
                var offsetTop = ($(window).height() - pHeight) / 2;
                $YTPlayerPlayer.width(width).height(pHeight).css({
                    left: 0,
                    position: "absolute",
                    "z-index": "-1",
                    top: 0 //offsetTop
                }); // player height is greater, offset top; reset left
            }

            console.log("width " + width);
            console.log("height " + height);
            console.log("pWidth " + pWidth);
            console.log("pHeight " + pHeight);

            //var jwidth = $(window).outerWidth();

            //var wWidth = $(window).outerWidth() + 100,
            //    wHeight = $(window).outerHeight(),
            //    cHeight = $("#slider").height(),
            //    cWidth = container.width(),
            //    $YTPlayerPlayer = $('#' + self.holderID);

            //var top = -(wHeight - cHeight) / 2;

            //console.log("wHeight " + wHeight);
            //console.log("wWidth " + wWidth);
            //console.log("cHeight " + cHeight);
            //console.log("cWidth " + cWidth);
            //console.log("top " + top);
            //console.log($YTPlayerPlayer);
            //$YTPlayerPlayer.width(wWidth).css({
            //    left: -10,
            //    top: top,
            //    position: "absolute"
            //});

            $YTPlayerPlayer = null;
            container = null;
        },

        /**
         * @function onYouTubeIframeAPIReady
         * @ params {object} YTPlayer object for access to options
         * Youtube API calls this function when the player is ready.
         */
        onYouTubeIframeAPIReady: function onYouTubeIframeAPIReady() {
            var self = this;
            self.player = new window.YT.Player(self.holderID, self.options);
        },

        /**
         * @function onPlayerReady
         * @ params {event} window event from youtube player
         */
        onPlayerReady: function onPlayerReady(e) {
            if (this.options.mute) {
                e.target.mute();
            }
            e.target.playVideo();
        },

        /**
         * @function getPlayer
         * returns youtube player
         */
        getPlayer: function getPlayer() {
            return this.player;
        },

        /**
         * @function destroy
         * destroys all!
         */
        destroy: function destroy() {
            var self = this;

            self.$node
                .removeData('yt-init')
                .removeData('ytPlayer')
                .removeClass('loaded');

            self.$YTPlayerString.remove();

            $(window).off('resize.YTplayer' + self.ID);
            $(window).off('scroll.YTplayer' + self.ID);
            self.$body = null;
            self.$node = null;
            self.$YTPlayerString = null;
            self.player.destroy();
            self.player = null;
        }
    };

    // Scroll Stopped event.
    $.fn.scrollStopped = function (callback) {
        var $this = $(this), self = this;
        $this.scroll(function () {
            if ($this.data('scrollTimeout')) {
                clearTimeout($this.data('scrollTimeout'));
            }
            $this.data('scrollTimeout', setTimeout(callback, 250, self));
        });
    };

    // Create plugin
    $.fn.YTPlayer = function (options) {
        return this.each(function () {
            var el = this;

            $(el).data("yt-init", true);
            var player = Object.create(YTPlayer);
            player.init(el, options);
            $.data(el, "ytPlayer", player);
        });
    };
})(jQuery, window, document);